// Customer discount by item sub-category (module customer_subcategory_discount,
// 2026-10-13). Off by default; switched on per company in Super Admin → Manage
// Modules.
//
// Each customer can carry a discount % per sub-category, saved on the customer
// itself:  customer.subCategoryDiscounts = { <subCategoryId>: <percent> }
// (no extra reads — sales screens already have the customer loaded).
//
// On Sale Invoice, Non-Tax Invoice, Quotation and Sale Order, an item added
// for that customer takes its sub-category's %. Items whose sub-category has no
// % fall back to the customer's Default Discount % where that screen already
// uses it (Sale Invoice, Sale Order), else 0. The line discount can still be
// changed by hand. Not used on POS. Lines already on a document never change.

export const SUBCAT_DISCOUNT_MODULE_ID = 'customer_subcategory_discount';

const pct = (v) => {
  if (v === '' || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 ? n : null;
};

/** The customer's sub-category discounts as numbers, or null when there are none. */
export const subCategoryDiscountMap = (customer) => {
  const raw = customer && customer.subCategoryDiscounts;
  if (!raw || typeof raw !== 'object') return null;
  const out = {};
  Object.entries(raw).forEach(([id, v]) => { const n = pct(v); if (id && n !== null) out[id] = n; });
  return Object.keys(out).length ? out : null;
};

/**
 * Discount % for a line when `item` is added for `customer`, or undefined to
 * leave the line exactly as the screen made it (module off, or this customer
 * has no sub-category discounts).
 *   item's sub-category % → else `fallback` (customer Default Discount %) → else 0
 */
export const subCategoryLineDiscount = (customer, item, isModuleEnabled, fallback = null) => {
  if (typeof isModuleEnabled !== 'function' || !isModuleEnabled(SUBCAT_DISCOUNT_MODULE_ID)) return undefined;
  const map = subCategoryDiscountMap(customer);
  if (!map) return undefined;
  const own = item && item.subCategoryId ? map[item.subCategoryId] : undefined;
  if (own !== undefined) return own;
  const fb = pct(fallback);
  return fb !== null ? fb : 0;
};

/** Customer screen: the typed boxes → what is saved (blank boxes left out). */
export const cleanSubCategoryDiscounts = (boxes) => {
  const out = {};
  Object.entries(boxes || {}).forEach(([id, v]) => { const n = pct(v); if (id && n !== null) out[id] = n; });
  return out;
};
